import gql from 'graphql-tag';

const GET_LIQUIDM_PUBLISHERS = gql`
  query liquidMPublishers {
    liquidMPublishers
  }
`;

export default GET_LIQUIDM_PUBLISHERS;
